import script from "./user-avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-avatar.vue?vue&type=script&setup=true&lang=ts"

import "./user-avatar.vue?vue&type=style&index=0&id=7ab60978&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab60978"]])

export default __exports__